export class SubCategoryWiseActAndBudgetRevenueDetails {
    date: string;
    categoryName:string;
    actual:number;
    budget:number;
    last_yr_actual: number;
    divisionCode?: string;
    uom: string;
}